import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {jwtDecode} from "jwt-decode";
import _ from 'lodash';
import {IAccessTokenDetails, IAuthenticationTokens} from "../types";


// Define a type for the slice state
// type UserState = IAuthenticationTokens & IAccessTokenDetails
type UserState = IAuthenticationTokens & {
    user?: IAccessTokenDetails
    isAuthenticated: boolean
};

// Define the initial state using that type
const initialState: UserState = {isAuthenticated: false} as UserState;

export const userSlice = createSlice({
    name: 'user',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        unsetAuthToken: state => {
            sessionStorage.removeItem('sess');
            state.isAuthenticated = false;
            state.AccessToken = undefined;
            state.IdToken = undefined;
            state.RefreshToken = undefined;
            state.ExpiresIn = undefined;
            state.TokenType = undefined;
            state.user = undefined;
        },
        // Use the PayloadAction type to declare the contents of `action.payload`
        setAuthToken: (state, action: PayloadAction<UserState>) => {
            Object.assign(state, _.pick(action.payload, ['AccessToken', 'IdToken', 'RefreshToken', 'ExpiresIn', 'TokenType']))
            state.user = action.payload.user;
            state.isAuthenticated = true
            sessionStorage.setItem('sess', JSON.stringify(action.payload));
        },
        loadSession: (state: UserState) => {
            let sess: string | null | UserState = sessionStorage.getItem('sess');
            if (sess) {
                try {
                    const sessObj = JSON.parse(sess) as UserState;
                    if (['AccessToken', 'IdToken', 'RefreshToken', 'ExpiresIn', 'TokenType', 'user']
                        .every(i => sessObj?.hasOwnProperty(i) && !_.isNil(sessObj[i as keyof UserState]))) {
                        const {exp} = jwtDecode(sessObj.AccessToken ?? '') as { exp: number };
                        if (exp * 1000 < new Date().getTime()) { // Token expired
                            sessionStorage.removeItem('sess');
                            return;
                        }
                        Object.assign(state, {isAuthenticated: true}, _.pick(sessObj, ['AccessToken', 'IdToken', 'RefreshToken', 'ExpiresIn', 'TokenType', 'user']))
                    }
                } catch (e) {
                    // Not a json, not my sess object
                }
            }
        }
    },
});

export const {unsetAuthToken, setAuthToken, loadSession} = userSlice.actions;

// Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value;

export default userSlice.reducer;
